import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";
import ModuleQuestion from "../../components/ModuleQuestion";

const Module_1_0 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">3.0.13 Case 13</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="A"
          assessmentName="self_assessment_113"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is self-assessment case number one, one, three, or 113.
                This is a positive case. Beginning at the level of the
                cerebellum and moving superiorly to the temporal and occipital
                lobes, at this level it is clear that there is loss of
                gray-white contrast in the right temporal lobe, seen here.
                Increased activity is seen within the gray matter, extending to
                the cortical rim throughout the right temporal lobe. On the
                left-hand side, however, there is preservation of a white matter
                tract, which can be seen here. And, in fact, gray- white
                contrast is preserved; however, this does not negate the fact
                that on the right-hand side there is loss of gray-white
                contrast. Moving superiorly and entering into the frontal
                cortices, it is clear that there is complete loss of gray-white
                contrast. White matter tracts cannot be distinguished from the
                surrounding gray matter. In fact, gray-matter uptake exceeds
                that of the white matter. Continuing superiorly, distinct white
                matter tracts are not seen coursing from the front to the back
                of the brain on the lefthand side or the right-hand side. In
                addition, in the posterior aspect of the brain within the
                parietal region, there is also loss of gray-white contrast,
                which can be seen here, on the right, as well as on the left.
                Continuing upwards, this pattern continues with clear loss of
                gray-white contrast throughout the parietal region. After
                reviewing all the slices, it is clear that there is loss of
                gray-white contrast in the parietal and temporal lobes and, most
                distinctly, within the frontal cortices bilaterally. Therefore,
                this case is positive. If you called this case negative, please
                review the case once again in the MIM Viewer, concentrating on
                the regions described.
              </p>
            </>
          }
          previousLesson="/module-3/module-3-0-12"
          nextLesson="/module-3/module-3-0-14"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_301671301&entry_id=1_79s33b7v&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          questionType="assessment"
          videoId="1_79s33b7v"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
